import { render } from "./DashboardAc.vue?vue&type=template&id=b742b4fa&scoped=true"
import script from "./DashboardAc.vue?vue&type=script&lang=js"
export * from "./DashboardAc.vue?vue&type=script&lang=js"

import "./DashboardAc.vue?vue&type=style&index=0&id=b742b4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b742b4fa"]])

export default __exports__